import { policyDocs } from '@/common/CanceledPolicy';
import Admin from './Admin';
import LiveChat from './LiveChat';
import RiskResources from './RiskResources';
import Staff from './Staff';

const Global = [
	{
		path: '/notifications',
		name: 'notications',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/Notifications/Notifications.vue'),
		meta: {
			title: 'MyAccount Messages',
			auth: true,
		},
	},
	{
		path: '/user/profile',
		name: 'userprofile',
		component: () => import(/* webpackChunkName: "Global" */ '@/pages/Account/MyProfile.vue'),
		meta: {
			title: 'User Profile',
			auth: true,
		},
	},
	{
		path: '/registration',
		name: 'registration',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/Auth/PostRegistration.vue'),
		meta: {
			title: 'Post Registration',
			auth: true,
		},
	},
	{
		path: '/error',
		name: 'error',
		component: () => import(/* webpackChunkName: "Global" */ '@/pages/Error/Error.vue'),
		meta: {
			title: 'Error',
			auth: false,
		},
	},
	{
		path: '/claims2',
		name: 'claims2',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/Claims/Global/ClaimsForm.vue'),
		meta: {
			title: 'Claims Form 2.0',
			auth: true,
		},
	},
	{
		path: '/public-claims-form',
		name: 'public-claims-form',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/Claims/Global/ClaimsForm.vue'),
		meta: {
			title: 'Claims Form 2.0',
			auth: false,
			preferAuthedLocation: '/claims2',
		},
	},
	{
		path: '/new-public-claims-form',
		name: 'new-public-claims-form',
		beforeEnter(to, from, next) {
			// New public claims form
			window.location.replace(process.env.VUE_APP_REDIRECT_PUBLIC_CLAIM);
	}
	},
	{
		path: '/login',
		name: 'login',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/RegistrationFlow/SignInRegister.vue'),
		meta: {
			title: 'Login',
			auth: false,
		},
	},
	{
		path: '/signout',
		name: 'singout',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/RegistrationFlow/Signout.vue'),
		meta: {
			title: 'Signout',
			auth: true,
		},
	},
        {
                path: '/verifycode',
                name: 'verifycode',
                component: () => import(/* webpackChunkName: "Global" */ '@/pages/Auth/VerifyCode.vue'),
                meta: {
                        title: 'Authenticating...',
                        auth: false,
                },
        },
	{
		path: '/quick-questions',
		name: 'quick-questions',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/RegistrationFlow/QuickQuestions.vue'),
		meta: {
			title: 'QuickQuestions',
			auth: false,
		},
	},
	{
		path: '/account-setup',
		name: 'account-setup',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/RegistrationFlow/AccountSetup.vue'),
		meta: {
			title: 'AccountSetup',
			auth: false,
		},
	},
	{
		path: '/verify-email',
		name: 'verify-email',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/RegistrationFlow/VerifyEmail.vue'),
		meta: {
			title: 'VerifyEmail',
			auth: false,
		},
	},
	{
		path: '/verify-phone',
		name: 'verify-phone',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/RegistrationFlow/VerifyPhone.vue'),
		meta: {
			title: 'VerifyPhone',
			auth: false,
		},
	},
	{
		path: '/confirm-signin',
		name: 'confirm-signin',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/RegistrationFlow/ConfirmSignIn.vue'),
		meta: {
			title: 'ConfirmSignIn',
			auth: false,
		},
	},
	{
		path: '/forgot-password',
		name: 'forgot-password',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/RegistrationFlow/ForgotPassword.vue'),
		meta: {
			title: 'ForgotPassword',
			auth: false,
		},
	},
	{
		path: '/reset-password',
		name: 'reset-password',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/RegistrationFlow/ResetPassword.vue'),
		meta: {
			title: 'ResetPassword',
			auth: false,
		},
	},
	{
		path: '/signout',
		name: 'signout',
		component: () => import(/* webpackChunkName: "Global" */ '@/pages/Auth/Signout.vue'),
		meta: {
			title: 'Signout',
			auth: false,
		},
	},
	{
		path: '/policy',
		name: 'policydocs',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/Policy/Mmic/MmicPolicy.vue'),
		meta: {
			title: 'Policy Docs',
			auth: true,
			canceledPolicies: policyDocs,
		},
	},
	{
		path: '/sunlight-quote-page',
		name: 'sunlight-quote',
		component: () =>
			import(/* webpackChunkName: "Global" */ '@/pages/Policy/SunlightQuotePage.vue'),
		meta: {
			title: 'Sunlight Quote Page',
			auth: true
		},
	},
	{
		path: '*',
		name: 'notfound',
		component: () => import(/* webpackChunkName: "Global" */ '@/pages/Error/Error.vue'),
		meta: {
			title: 'Error',
			auth: false,
		},
		params: {
			message: "Page doesn't exists",
		},
	},
	...RiskResources,
	...Staff,
	...Admin,
	...LiveChat,
];

export default Global;
